import React, { useCallback} from "react";
import styled from "styled-components";

const Root = styled.div`
  width: ${props => props.width || "fit-content"};
  min-width: 27.6rem;
  min-height: 36.7rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 2.6rem;
  color: ${props => props.theme.colors.primary.green};
  text-shadow: white !important;
  position: relative;
  box-sizing: border-box;
  box-shadow: 0px 0px 30px #0000004d;
  &:hover {
    color: ${props => props.theme.colors.primary.white};
  }
`;

const Name = styled.div`
  position: absolute;
  bottom: 0;
  margin-bottom: 20px;
  font-size: 2.5rem;
  font-weight: ${props => props.theme.fontWeight.bold};
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 1);
  line-height: 4.3rem;
  z-index: 1;
`;

const Role = styled.div`
  position: absolute;
  bottom: 0;
  font-size: 1.8rem;
  font-weight: ${props => props.theme.fontWeight.regular};
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 1);
  line-height: 1.9rem;
  z-index: 1;
`;

const AvatarImg = styled.img`
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  filter: grayscale(100%);
  transition: filter 0.5s ease-in-out;
  &:hover {
    filter: grayscale(0%);
  }
`;

const Description = styled.div`
  text-align: justify;
  text-justify: inter-word;
  cursor: pointer;
  position: absolute;
  padding: 20px;
  left: 0px;
  top: 0;
  font-size: 1.6rem;
  color: ${props => props.theme.colors.primary.white};
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 1);
  line-height: 2rem;
  z-index: 11;
`;

const DescOverlay = styled.div`
  cursor: pointer;
  left: 0;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  background: ${props => props.theme.colors.primary.black};
  opacity: 0.8;
  z-index: 10;
`;

export const AvatarCard = ({ img, name, role, description, onClick }) => {
  const [isDisplayingDesc, setIsDisplayingDesc] = React.useState(false);
  const handleClick = useCallback(() => {
    if(onClick) onClick();
  }, [onClick]);

  const handleTeamMemberClick = useCallback(() => {
    setIsDisplayingDesc(true);
  });

  const handleDescriptionClick = useCallback(() => {
    setIsDisplayingDesc(false);
  });

  return (
    <Root onClick={handleClick}>
      <Name>{name}</Name>
      <Role>{role}</Role>
      <AvatarImg src={img} onClick={handleTeamMemberClick} />
      {
        isDisplayingDesc
            ? <>
                <DescOverlay onClick={handleDescriptionClick}/>
                <Description onClick={handleDescriptionClick}>{description}</Description>
              </>
            : ''

      }

    </Root>
  );
};
